import { ProductCode } from "./product-code.constant";

export enum ServiceRequest {
    SCREEN_CRACK = "Screen Crack",
    ACCIDENTAL_DAMAGE = "Accidental and Liquid Damage",
    LOST_THEFT = "Lost/Attended Theft",

    CHUBB_ACCIDENTAL_DAMAGE = "AccidentalDamage",
    CHUBB_THEFT = "Theft",

    MEDICAL_EXPENSES = "Medical Expenses",
    ITEM_PURCHASED_VALUE_REIMBURSEMENT = "Item Purchased Value Reimbursement",
    EMERGENCY_HOSPITALIZATION = "Emergency Hospitalization",
    ACCIDENTAL_DEATH = "Accidental Death",
}

export const SERVICE_REQUEST_OPTIONS: Partial<Record<ProductCode, ServiceRequest[]>> = {
    [ProductCode.EP]: [ServiceRequest.SCREEN_CRACK, ServiceRequest.ACCIDENTAL_DAMAGE, ServiceRequest.LOST_THEFT],
    [ProductCode.GP]: [ServiceRequest.SCREEN_CRACK, ServiceRequest.ACCIDENTAL_DAMAGE, ServiceRequest.LOST_THEFT],
    [ProductCode.TM_MP]: [ServiceRequest.ACCIDENTAL_DAMAGE],
    [ProductCode.AP]: [
        ServiceRequest.MEDICAL_EXPENSES,
        ServiceRequest.ITEM_PURCHASED_VALUE_REIMBURSEMENT,
        ServiceRequest.EMERGENCY_HOSPITALIZATION,
        ServiceRequest.ACCIDENTAL_DEATH,
    ],
    [ProductCode.CH_GP]: [ServiceRequest.CHUBB_ACCIDENTAL_DAMAGE, ServiceRequest.CHUBB_THEFT],
    [ProductCode.CH_EP]: [ServiceRequest.CHUBB_ACCIDENTAL_DAMAGE, ServiceRequest.CHUBB_THEFT],
    [ProductCode.CH_MP]: [ServiceRequest.CHUBB_ACCIDENTAL_DAMAGE, ServiceRequest.CHUBB_THEFT],
};
